import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Etusivu" />
    <div style={boldText}>PIHA- MAISEMASUUNNITTELU</div>
    <div>
      <div style={textBox}>
        <p>
          Yli 30 vuoden kokemuksella tarjoamme korkealaatuista piha- ja
          maisemasuunnittelua, rakennuttamista ja työmaavalvontaa.
        </p>
      </div>
      <div style={textBox}>
        <p
          style={{
            textDecoration: "underline",
          }}
        >
          Suunnittelutehtäviä vuosien varrella ovat olleet
        </p>
        <p>• viheralueiden uudisrakentamiset ja perusparannukset</p>
        <div>• julkiset ja yksityiset ympäristöt ja virkistysalueet</div>
        <div style={inlineText}>
          o teema- ja monitoimipuistot, leikkialueet, koulu- päiväkoti- ja
          senioripihat
        </div>
        <div style={inlineText}> o seurakuntien ja sairaalaympäristöalueet</div>
        <div style={inlineText}>
          {" "}
          o kiinteistö-, taloyhtiö- ja yksityispihat
        </div>
        <div style={inlineText}> o edustusviheralueet </div>
        <div style={inlineText}> o historialliset piha- ja puistoalueet</div>
      </div>
      <div style={textBox}>
        <p>
          Suunnittelupalvelujen tilaajina ovat olleet kuntien ja valtion
          virastoja, seurakuntia, kiinteistö- ja taloyhtiöitä,
          arkkitehtitoimistoja, rakennusliikkeitä ja yksityisiä talouksia.
        </p>
      </div>
    </div>
  </Layout>
)

const textBox = {
  marginTop: "40px",
}

const inlineText = {
  marginLeft: "10px",
}

const boldText = {
  fontWeight: "900",
}

export default IndexPage
